import React from "react";
import { withRouter } from "react-router-dom";
import { makeStyles } from "@material-ui/styles";
import { Grid, Typography, FormControl, InputLabel, TextField, MenuItem } from "@material-ui/core";
import Button from "../../components/UI/Button/Button";
import Alert from "../../components/UI/Alert/Alert";

// provider
import { useUser } from "../../providers/App/User/UserProvider";
import { useStore } from "../../providers/App/Store/StoreProvider";

const Login = () => {
  // global
  const { authenticationState, signIn } = useUser();
  const { storesList, storeState, setStoreState } = useStore();

  const handleChange = (event) => {
    for(let index = 0; index<storesList.length; index+=1){
      if(storesList[index].id === event.target.value){
        setStoreState(storesList[index].id, storesList[index].name, storesList[index].base_url, storesList[index].api_key);
        return;
      }
    }
  };

  const useStyles = makeStyles(() => ({
    container: {
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)"
    },
    logo: {
      width: "64%"
    },
    formControl: {
      width: "215px"
    },
    alert: {
      position: "fixed",
      top: "15%",
      left: "50%",
      transform: "translateX(-50%)"
    }
  }));
  const classes = useStyles();

  return (
    <>
      <Grid container className={[classes.container, "p-l-16 p-t-16 p-r-16 p-b-16 text-align-center"].join(" ")} spacing={2}>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <img src="/assets/images/Logo.png" className={[classes.logo, "img-responsive"].join(" ")} alt="6thStreet.com" />
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="p-t-16 p-b-16">
          <Typography variant="h2">
            ReCan
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <FormControl variant="outlined" margin="dense" className={classes.formControl}>
            <TextField
              select
              variant="outlined"
              margin="dense"
              key={0}
              label="Select Store"
              placeholder="Please Select"
              value={storeState.id}
              onChange={handleChange}
            >
              {
                storesList && storesList.map((item) => {
                  return (
                    <MenuItem
                      key={item.id}
                      value={item.id}
                      label={item.name}
                    >
                      {item.name}
                    </MenuItem>
                  );
                })
              }
            </TextField>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Button
            onClick={signIn}
          >
            <img className="img-responsive text-align-center" alt="Sign in with Microsoft" src="/assets/images/SignInWithMicrosoft.svg" />
          </Button>
        </Grid>
      </Grid>
      {
        authenticationState.error
        ?
        <Alert className={classes.alert} severity="error" title="Error" message={authenticationState.error} />
        :
        null
      }
    </>
  );
}

export default withRouter(Login);
